export default __webpack_public_path__ + "static/media/AboutCard3.1cce2473.png";